<template>
  <baidu-map
    :center="center"
    :zoom="zoom"
    @ready="handler"
    style="height:520px"
    @click="getClickInfo"
    :scroll-wheel-zoom="true"
    class="baiduMap"
  ></baidu-map>
</template>
<script>
export default {
  name: "commonmap",
  components: {},
  data() {
    return {
      center: { lng: 112.874147, lat: 28.218135 },
      zoom: 13
    };
  },
  mounted() {},
  methods: {
    handler({ BMap, map }) {
      var point = new BMap.Point( 112.874147, 28.218135);
      map.centerAndZoom(point, 13);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      var circle = new BMap.Circle(point, 6, {
        strokeColor: "Red",
        strokeWeight: 6,
        strokeOpacity: 1,
        Color: "Red",
        fillColor: "#f03"
      });
      map.addOverlay(circle);
    },
    getClickInfo(e) {
      console.log(e.point.lng);
      console.log(e.point.lat);
      this.center.lng = e.point.lng;
      this.center.lat = e.point.lat;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.baiduMap
    height 616px!important
</style>


// WEBPACK FOOTER //
// src/components/common/commonmap.vue